import { useMemo } from "react";
import { useTheme } from "@fluentui/react/lib/Theme";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";

const classNames = {
  root: `ImageList`,
  icon: `ImageListIcon`
};

export function useImageListValueStyles() {
  const { semanticColors } = useTheme();
  return useMemo(
    () => mergeStyleSets({
      root: [classNames.root],
      icon: [
        classNames.icon,
        {
          paddingBottom: `6px`,
          marginRight: `5px`,
          color: semanticColors.link
        }
      ]
    }),
    [semanticColors]
  );
}
